/**
 * Styled Components - Created by david on 10/04/18.
 */
import styled from 'styled-components'
import Switch from 'antd/lib/switch'
import Icon from 'antd/lib/icon'
import { BLUE, RED, WHITE } from '../../theme/colors'

export const Container = styled.div`
  width: 25%;
  margin-top: 30px;

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
    margin-right: 0;
  }

  @media (min-width: 481px) and (max-width: 1024px) {
    width: 45%;
  }
  &.storeForm {
    width: 100%;
    @media (max-width: 480px) {
      margin-top: 0px;
    }
  }
  &.createStore {
    width: fit-content;
    margin-block: 10px -24px;
  }
`
export const SwitchInput = styled(Switch)`
  &.ant-switch-checked {
    background: ${BLUE};
  }
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`

export const Text = styled.div`
  color: #fff;
`

export const Label = styled.div`
  color: #5f6062;
  font-size: 14px;
  font-weight: 500;
  line-height: 25px;
  &.storeForm {
    @media (max-width: 698px) {
      max-width: 168px;
      line-height: 16px;
    }
  }
`

export const Message = styled.div`
  color: #8c8c8c;
  font-size: 14px;
  span {
    color: #625F5F;
    font-weight: 600;
    text-decoration: underline;
  }
  @media (max-width: 360px) {
    font-size: 13px;
  }
`

export const SubLabel = styled.div`
  color: #8c8c8c;
  font-size: 12px;
  font-size: 12px;
  margin: 6px 4px 0;
`

export const InputDiv = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 12px;
  width: 500px;
  @media (max-width: 598px) {
    width: auto;
    flex-wrap: wrap;
  }
`

export const CurrentCode = styled.div`
  display: flex;
  background: #f4f4f4;
  padding: 8px 16px;
  border-radius: 25px;
  margin-right: 28px;
  font-family: Avenir;
  white-space: nowrap;
  @media (max-width: 598px) {
    margin-top: 12px;
    margin-right: 0;
    width: 100%;
    justify-content: center;
  }
`

export const CodeLabel = styled.div`
  font-weight: 500;
  margin-right: 8px;
`

export const inputStyle = {
  width: '100%',
  marginTop: 16
}

export const Error = styled.div`
  color: #e61737;
  font-size: 12px;
  line-height: 16px;
  padding: 4px;
`

export const Question = styled(Icon)`
  margin-top: 2px;
  margin-inline: 8px;
  cursor: pointer;
`

export const LabelInput = styled.div`
  font-size: 12px;
  margin-top: -10px;
  margin-bottom: 1px;
`

export const ResetButton = styled.div`
  border: 1px solid red;
  color: red;
  padding: 6px 12px;
  border-radius: 5px;
  box-shadow: 1px 2px 2px 0px #e3e3e3;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${RED};
    color: ${WHITE};
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SwitchWithLabel/styledComponents.tsx